module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/advice-77f34a5daa528fafd29e23ac71a48f5e.jpg";